import { useCallback, useMemo, useState } from 'react';
import Canvas3D from './components/Canvas3D';
import EditorUI from './components/EditorUI';
import { CITY_SITES, getSiteById } from './config/sites';
import { exportSceneAsGLTF, getCurrentScene } from './utils/gltf';
import styles from './App.module.css';

function App() {
  const [siteId, setSiteId] = useState('mall-bulevar-del-alcazar');
  const site = getSiteById(siteId);

  // Sitios ordenados alfabéticamente por nombre (ignora acentos)
  const sortedSites = useMemo(
    () =>
      [...CITY_SITES].sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
      ),
    []
  );

  // Exportar la escena 3D actual como GLTF
  const handleExportGLTF = useCallback(() => {
    const scene = getCurrentScene();
    if (scene) {
      exportSceneAsGLTF(scene, site.name);
    } else {
      window.alert('No hay escena disponible para exportar.');
    }
  }, [site.name]);

  return (
    <div className={styles.container}>
      <Canvas3D
        lat={site.lat}
        lng={site.lng}
        radius={site.radius}
        includeRoads
        seedUrl={site.seedUrl}
        siteName={site.name}
      />

      {/* Interfaz de editor (barra de herramientas, panel de propiedades, etc.) */}
      <EditorUI onExport={handleExportGLTF} />

      {/* Menú de selección de sitio */}
      <div className={styles.siteSelector}>
        <label htmlFor="site-select" className={styles.siteLabel}>
          Sitio:
        </label>
        <select
          id="site-select"
          value={site.id}
          onChange={(e) => setSiteId(e.target.value)}
          className={styles.siteSelect}
        >
          {sortedSites.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name} ({s.radius}m)
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default App;